// @owners { team: patients }
import { SPACING } from '@alto/design-library-tokens';
import { Button, Card, Description, LgPadding, MdSpacing } from '@alto/design-system';
import React, { useEffect } from 'react';
import { Linking } from 'react-native';
import { getImage } from '~shared/assets/images/getImage';
import { IMG_ALT_TEXTS, PROGYNY_UNBOXING_GUIDE_URL } from '~shared/constants';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';

export const ProgynyUnboxingGuide = () => {
  const { trackEvent, trackPageView } = useAnalytics();

  const onPressUnboxingGuide = () => {
    trackEvent({ event: EVENTS.UNBOXING_GUIDE_TAPPED });
    Linking.openURL(PROGYNY_UNBOXING_GUIDE_URL);
  };

  useEffect(() => {
    trackPageView({
      event: EVENTS.ALTO_EDU_UNBOXING_GUIDE_VIEWED,
    });
  }, [trackPageView]);

  return (
    <Card
      title="Prepare for your upcoming order"
      illustrationSrc={getImage('fertilityPackageDelivered')}
      illustrationAccessibilityLabel={IMG_ALT_TEXTS.fertilityPackageCheckmark}
    >
      <LgPadding topPadding={SPACING.STATIC.MD}>
        <Description>See helpful information, including unboxing and storage guidance</Description>
        <MdSpacing />
        <Button
          width="inline"
          type="primary"
          label="See unboxing guide"
          onPress={onPressUnboxingGuide}
        />
      </LgPadding>
    </Card>
  );
};
